"use client";

import { AdminBarAction, setAdminBarActions } from "@/app/store/slices/adminBar/adminBarSlice";
import { useAppDispatch } from "@v2/lib/redux/hooks";
import { useEffect } from "react";

export default function AdminBarSetter({ actions }: { actions: AdminBarAction[] }) {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(setAdminBarActions(actions));
        return () => { dispatch(setAdminBarActions([])); };
    }, [JSON.stringify(actions)]);

    return null;
}
